import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard
    isLocked
    to="/submit-sc"
    image="/static/img/Card-SubmitATicket.png"
    imageAlt="Man submitting service call in diner"
    description="Submit a Support Ticket"
    loggedOutDescription="Log in to Submit a Support Ticket"
  >
    Get started by asking Skyward a question
  </FeatureCard>
);
